<template>
  <div id="bad-navigator">
    <img class="bad-logo" src="../assets/logo.png" alt="Logo KPAM">
    <img class="bad-icon" src="../assets/icons/invisible.png" alt="bad navigator">
    <p class="text-2" v-html="$t('badNavigator')"></p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "src/assets/css/variables.scss";
#bad-navigator {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  > .bad-logo {
    width: 100px;
    height: auto;
    margin: 3em 0;
  }
  .bad-icon {
    background-color: $green;
    border-radius: 50%;
    padding: 10px;
    height: 35px;
    width: 35px;
  }
  > * {
    margin: 1em 0;
  }
  p {
    width: 1000px;
    margin: 0 auto;
    text-align: center;
    max-width: 90%;
    font-weight: bold;
    white-space: pre-wrap;
  }
}
</style>
